export default "__VITE_ASSET__791a22d1__"